import { render, staticRenderFns } from "./myPagination.vue?vue&type=template&id=5bd8e365&scoped=true&"
import script from "./myPagination.vue?vue&type=script&lang=js&"
export * from "./myPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd8e365",
  null
  
)

export default component.exports